import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyDacqcBg9ar1gBTQRaBxj4yn1wJPghUgrw",
  authDomain: "hpmn-e70ff.firebaseapp.com",
  projectId: "hpmn-e70ff",
  storageBucket: "hpmn-e70ff.appspot.com",
  messagingSenderId: "800553815069",
  appId: "1:800553815069:web:62907c581c1712174ecaf4",
  measurementId: "G-ELG7P4TF05"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
firebase.analytics();
export { db, auth };
